import './style.scss';
import Fontpicker from './fontpicker.js';

export default Fontpicker;